import { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { PrinterIcon  } from '@heroicons/react/24/outline'
import {
    DataGrid,
    gridClasses,
    GridColDef,
    GridToolbarQuickFilter,
    gridPageCountSelector,
    GridPagination,
    useGridApiContext,
    useGridSelector,
  } from '@mui/x-data-grid';
import MuiPagination from '@mui/material/Pagination';
import { Avatar } from '@mui/material'
  
const apiurl = `${process.env.REACT_APP_API}`;
const imgurl = `${process.env.REACT_APP_URL}`

function numberWithCommas (nStr) {
    nStr += '';
      let x = nStr.split('.');
      let x1 = x[0];
      let x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
          x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      x = x1 + x2;
      if(x.substr(0,1) === '.'){
          x = '0' + x;
      }
      return x + '฿';
};
  

const Reports = () => {
    const [orders, setOrders] = useState([]);
    const [saledata, setSaleData] = useState([]);
    const [dailyChart, setDailyChart] = useState(null);
    const [reporttype, setReportType] = useState('');
    const [loading, setLoading] = useState(false);
    const [chartloading, setChartLoading] = useState(false);
    const [dfrom, setDfrom] = useState();
    const [dto, setDto] = useState();
    const [errMsg, setErrMsg] = useState({type:'', info:''});
    const [totalRow, settotalRow] = useState(0);
    // const [paginationModel, setPaginationModel] = useState({
    //     page: 0,
    //     pageSize: 100,
    //   });

    // const [rowCount ,setRowCount] = useState({
    //     rowCount: totalRow,
    // })

    function Pagination({ page, onPageChange, className }) {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);

        return (
            <MuiPagination
            color="primary"
            className={className}
            count={pageCount}
            page={page + 1}
            onChange={(event, newPage) => {
                onPageChange(event, newPage - 1);
            }}
            />
        );
    }

    function CustomPagination(props) {
        return <GridPagination ActionsComponent={Pagination} {...props} />;
    }
    
  
    const columns: GridColDef[] = [
        { field: "date", type: "string", headerName: "Date", headerAlign: 'center', width: 110, },
        {
          field: "img",
          headerName: "Image",
          renderCell:params=><Avatar variant="rounded" src={`${imgurl}/image/products/${params.row.img}`} />,
          sortable: false,
          filterable: false,
          headerAlign: 'center',
          width: 100,
          editable: false,
      
          // renderCell: (params) => {
          //   return <img src={`${process.env.REACT_APP_URL}/image/users/${params.row.Avatar} || '/user.png'`} alt="" />;
          // },
        },
        {
          field: "prodName",
          type: "string",
          headerName: "Name",
          headerAlign: 'center',
          minWidth: 150,
        //   width: 150,
          editable: false,
          flex: 1,
        },
        {
          field: "price",
          type: "number",
          headerName: "Price",
          minWidth: 120,
          editable: false,
        },
        {
          field: "qty",
          type: "number",
          headerName: "Qty",
          minWidth: 100,
          editable:false,
        },
        {
          field: "amount",
          type: "number",
          headerName: "Amount",
          minWidth: 130,
          editable:false,
        },
    ];

    function sumtotal(items) {
        return items.reduce((sum, item) => sum + item.total * 1, 0);
        // return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
      }
    

    const fetchOrders = async (period) => {
        setLoading(true);
        setReportType(period);
        let qs = "";
        if(period==="range") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

        try {
            const response = await axios.get(`${apiurl}/reports.php?${qs}`);
            // console.log(response);
            if(response.data.message==="OK") {
                // console.log(response.data.data);
                setOrders(response.data.data);
                setErrMsg({
                    type: '',
                    info: '',
                })
                let charttype = '';
                let saletype = ''
                if(period==='daily') {
                    charttype = "charttoday";
                    saletype = "saletoday";
                }
                else if(period==='sumdaily') {
                    charttype = "chartdaily";
                    saletype = "saledaily";
                }
                else if(period==='range') {
                    charttype = "chartrange";
                    saletype = "salerange";
                }
                else if(period==='sumweekly') {
                    charttype = "chartweekly";
                    saletype = "saleweekly";
                }
                else {
                    charttype = "chartmonthly";
                    saletype = "salemonthly";
                }

               await fetchOrderChart(charttype);
               await fetchSale(saletype);


            }  else {
                setErrMsg({
                    type: 'err',
                    info: 'No record found!!!',
                })
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        setLoading(false);
    };

    const fetchOrderChart = async (period) => {
        setChartLoading(true);
        // setReportType(period);
        let qs = "";
        if(period==="chartrange") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

        // console.log(qs);
        try {
            const response = await axios.get(`${apiurl}/reports.php?${qs}`);
            // console.log(response);
            if(response.data.message==="OK") {
                // setDailyChart(response.data.data);
                setDailyChart({
                    color: "#8884d8",
                    title: (period==='charttoday') ? "Today Chart" : (period==='chartrange' || period==='chartdaily') ? "Daily Chart" : (period==='chartweekly') ? "Weekly Chart" : "Monthly Chart",
                    dataKey: (period==='charttoday') ? "cashier" : (period==='chartrange' || period==='chartdaily') ? "day" : (period==='chartweekly') ? "day" : "month",
                    data: response.data.data,
                  });
            }
        } catch (error) {
            console.error('Error fetching summary:', error);
        }
        setChartLoading(false);
    };

    useEffect(() => {
        fetchOrders('daily');
      },[])

      const fetchSale = async (period) => {
        // setLoading(true);
        let qs = "";
        if(period==="salerange") {
            qs = `period=${period}&dfrom=${dfrom}&dto=${dto}`;
        } else {
            qs = `period=${period}`;
        } 

        try {
          const result = await axios.get(`${apiurl}/reports.php?${qs}`);
          
        //   console.log(result);
          if(result.data.message==="OK") {  
            setSaleData(result.data.data);
            setLoading(false);
          } else {
            console.log(result);
            setLoading(false);
          }
  
        }
        catch(err) {
            console.log(err);
            setLoading(false);
        }
    }
  
    // console.log(dailyChart);

    return (
        <div className="flex flex-col p-2 max-w-7xl h-[calc(100vh-140px)] overflow-y-auto mx-auto">
            <div className="flex flex-col md:flex-row p-2 gap-2 items-start justify-between print:hidden">
                <div>
                    <button onClick={() => fetchOrders('daily')} className="hover:text-green-500"> ToDay </button> <span> / </span>
                    <button onClick={() => fetchOrders('sumdaily')} className="hover:text-green-500"> Daily </button> <span> / </span>
                    <button onClick={() => fetchOrders('sumweekly')} className="hover:text-green-500"> Weekly </button> <span> / </span>
                    <button onClick={() => fetchOrders('summonthly')} className="hover:text-green-500"> Monthly </button>
                </div>
                <div  className="flex flex-row col-span-1 gap-2 items-end md:mr-8">
                    <div>
                        <label htmlFor="dfrom" className="block text-sm/6 font-medium text-gray-300">
                            From
                        </label>
                        <input
                            id="dfrom"
                            name="dfrom"
                            value={dfrom}
                            disabled={false}
                            onChange={(e) => setDfrom(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div>
                        <label htmlFor="dto" className="block text-sm/6 font-medium text-gray-300">
                            To
                        </label>
                        <input
                            id="dto"
                            name="dto"
                            value={dto}
                            disabled={false}
                            onChange={(e) => setDto(e.target.value)}
                            autoComplete="given-date"
                            type="date"
                            className="block sm:w-full rounded-md bg-slate-400 p-1 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                        />
                    </div>
                    <div  className="flex items-end col-span-1 gap-2">
                        <button 
                            type="button" 
                            // disabled={id===0 ? false : true}
                            className="rounded-md bg-teal-800 disabled:bg-slate-500 p-1 mt-2 md:mt-0 text-sm text-white shadow-sm hover:bg-teal-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={() => fetchOrders('range')}
                        >
                            Get Item
                        </button>
                    </div>
                </div>            
            </div>
            <div className="print:absolute print:top-0 print:left-0 print:w-full print:h-full print:z-50 print:bg-white print:text-black">
                <span>
                    Orders Report
                    <button onClick={() =>window.print()}>
                        <PrinterIcon 
                            className="inline-block h-6 w-6 ml-3 text-sky-500 cursor-pointer hover:text-sky-300"
                        />
                    </button>
                </span>
                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <div className="flex flex-col max-h-svh  overflow-y-auto p-2">
                        <table className="w-full table-auto">
                            <caption className="caption-bottom text-right py-4 text-lg pr-2">
                                Total : {numberWithCommas(sumtotal(orders))}
                            </caption> 
                            <thead>
                            {reporttype==="sumdaily" || reporttype==="daily" || reporttype==="range" ?
                                <tr className="border bg-slate-800">
                                    <th className="border font-normal">Order Date</th>
                                    <th className="border font-normal">Cashier</th>
                                    <th className="border font-normal">Cash</th>
                                    <th className="border font-normal">ScanQR</th>
                                    <th className="border font-normal">Total</th>
                                </tr>
                            : reporttype==="sumweekly" ?
                                <tr className="border bg-slate-800">
                                    <th className="border">Day</th>
                                    <th className="border">Date</th>
                                    <th className="border">Cashier</th>
                                    <th className="border">Cash</th>
                                    <th className="border">ScanQR</th>
                                    <th className="border">Total</th>
                                </tr>
                            : <tr className="border bg-slate-800">
                                <th className="border">Year</th>
                                <th className="border">Month</th>
                                <th className="border">Cashier</th>
                                <th className="border">Cash</th>
                                <th className="border">ScanQR</th>
                                <th className="border">Total</th>
                            </tr>
                            }
                            </thead>
                            <tbody>
                            {reporttype==="sumdaily" || reporttype==="daily" || reporttype==="range" ?
                                orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-blue-500">
                                        <td className="text-center border">{order.day}</td>
                                        <td className="text-center border">{order.cashier}</td>
                                        <td className="text-center border">{numberWithCommas(order.Cash)}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.total)}</td>
                                    </tr>
                                ))
                            : reporttype==="sumweekly" ?
                                orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-pink-400">
                                        <td className="text-center border">{order.days}</td>
                                        <td className="text-center border">{order.day}</td>
                                        <td className="text-center border">{order.cashier}</td>
                                        <td className="text-center border">{numberWithCommas(order.Cash)}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.total)}</td>
                                    </tr>
                                ))
                            : orders.map((order,i) => (
                                    <tr key={i} className="border odd:bg-teal-400">
                                        <td className="text-center border">{order.year}</td>
                                        <td className="text-center border">{order.month}</td>
                                        <td className="text-center border">{order.cashier}</td>
                                        <td className="text-center border">{numberWithCommas(order.Cash)}</td>
                                        <td className="text-center border">{numberWithCommas(order.ScanQR)}</td>
                                        <td className="text-right border pr-2">{numberWithCommas(order.total)}</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </table>

                        <p className={errMsg.type==='err'? "text-red-600" : "text-green-600"}>
                            {errMsg.info}
                        </p>
                    </div>
                )}
                
                {chartloading ? (
                    <p>Loading...</p>
                ) : ( dailyChart &&
                    <div className="w-full">
                        <h1 className="text-md mt-4">{dailyChart.title}</h1>
                        <div className="">
                            <ResponsiveContainer width="100%" height={250}>
                                <BarChart
                                    data={dailyChart.data}
                                    width={500}
                                    height={300}
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid stroke="#716e6e" strokeDasharray="3 3" />
                                    <XAxis dataKey={dailyChart.dataKey} stroke="#716e6e" />
                                    <YAxis stroke="#716e6e" />
                                    <Tooltip
                                        contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
                                        // labelStyle={{ display: "none" }}
                                        cursor={{fill:"none"}}
                                    />
                                    <Legend />
                                    <Bar dataKey="Cash" label={dailyChart.data.Cash} stackId="a" fill="#8884d8"  activeBar={<Rectangle fill="pink" stroke="blue" />} />
                                    <Bar dataKey="ScanQR"  label={dailyChart.data.ScanQR} stackId="a" fill="#82ca9d" activeBar={<Rectangle fill="gold" stroke="purple" />} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )}
                <div className="mt-2 w-svw sm:w-[calc(100vw-200px)]">
                {saledata && 
                <DataGrid 
                    checkboxSelection={false} 
                    rows={saledata} 
                    // rowCount={rowCountState}
                    columns={columns} 
                    density='compact'
                    initialState={{
                        pagination: { paginationModel: { pageSize: 25 } },
                            // columns: {
                            //     columnVisibilityModel: {
                            //         id: false,
                            //     },
                            // },
                        }}
                    // page={page}
                    // autoPageSize
                    // pageSize={pageSize}
                    // rowsPerPageOptions={[5,10,30,50,100]}
                    pageSizeOptions={[5, 10, 25,30, 50, 100, { value: -1, label: 'All' }]}
                    // pagination
                    // paginationMode="client"
                    // onPageChange={(newPage) => setPage(newPage)}
                    // onPageChange={handlePageChange}
                    // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    // onPageSizeChange={handlePageSizeChange}
                    // filterMode="server"
                    // onFilterModelChange={onFilterChange}
                    // disableSelectionOnClick
                    getRowId={(row) => row.date+row.prodName}
                    // onCellEditCommit={(params) => setRowId(params.id)}
                    // processRowUpdate={(updatedRow, originalRow) => {
                    // console.log(updatedRow);
                    // console.log(originalRow);
                    // getObjectChanges(originalRow, updatedRow)
                    // return updatedRow;
                    // setRowId(params.id)
                    // }}
                    // onCellClick={handleCellClick}
                    headerHeight={38}
                    slots={{ toolbar:  GridToolbarQuickFilter,
                            pagination: CustomPagination, 
                                // GridToolbarFilterButton,
                            
                    }}
                    // components={{
                    //         Toolbar: CustomToolbar,
                    //         // Pagination: CustomPagination,
                    //     // BaseCheckbox: CustomCheck,
                    // }}
                    // componentsProps={{
                    //   toolbar: {
                    //     showQuickFilter: true,
                    //     quickFilterProps: { debounceMs: 1000},
                    //   },
                    // }}
                    sx={{ 
                        // m:2,
                        [`& .${gridClasses.row}`]: {
                            bgcolor: '#f1e9e9',
                            // bgcolor: (theme) =>
                            // theme.palette.mode === 'light' ? grey[300] : grey[900],
                        },
                        [`& .${gridClasses.columnHeader}`] : {
                            bgcolor: '#0e0e7b',
                            color: '#ffffff',
                            // bgcolor: (theme) =>
                            //   theme.palette.mode === 'light' ? grey[500] : blue[800],
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal"
                        },
                        [`& .${gridClasses.footerContainer}`] : {
                            bgcolor: '#0a55b1',
                            color: '#ffffff',
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "skyblue"
                            // color: "red"
                        },
                        "& .MuiDataGrid-row.Mui-selected": {
                            bgcolor: '#0e6496',
                            color: '#ffffff',
                            '&:hover': {
                                bgcolor: '#1593c4',
                            },
                        },
                        "& .MuiSvgIcon-root": {
                            fill: "#9e9a9a",
                        },
                        "& .MuiInputBase-input.MuiInput-input": {
                            color: "#9e9a9a",
                        },
                        "& .MuiTablePagination-root": {
                            color: "#ffffff",
                        },
                        [`.${gridClasses.cell}.neg`]: {
                            backgroundColor: '#b9d5ff91',
                            color: '#ef0b0b',
                        },
                        [`.${gridClasses.cell}.pos`]: {
                        // backgroundColor: '#ff943975',
                        color: '#000000',
                        },
                        // [`& .${gridClasses.GridToolbarExport}`] : {
                        //   color: (theme) =>
                        //     theme.palette.mode === 'light' ? grey[200] : grey[700],
                        // },

                    }}
                    // getRowClassName={(params) => `super-app-theme--${params.row.status}`}
                    // getCellClassName={(params) => {
                    //     if (params.field === 'instock') {
                    //         return params.value < 0 ? 'neg' : 'pos';;
                    //     }
                    // }}
                    loading={loading}
                    // className="bg-gray-600 bg-gray-600"
                />
                }
                </div>
            </div>

        </div>
    );
};

export default Reports;
